import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        columnTitle: "全部",//文章列表标题
        city: "广东省",//当前城市
        index: "",//当前导航index
        artrcleNumber: "",//文章编号
        limit: "6",//限制
        searchContent: "",//搜索内容
        moreRecommend: "",//更多推荐文章
        addColumn: "",//
        adv1: {},//
    },      //状态管理
    mutations: {
        setColumnTitle(state, e) {
            state.columnTitle = e;
        },
        setCity(state, e) {
            state.city = e;
        },
        setIndex(state, e) {
            state.index = e;
        },
        setartrcleNumber(state, e) {
            state.artrcleNumber = e;
        },
        addLimit(state) {
            state.limit = Number(state.limit) + 3;
        },
        setSearchContent(state, e) {
            state.searchContent = e;
        },
        setmoreRecommend(state, e) {
            state.moreRecommend = e
        },
        setAddColumn(state, e) {
            state.addColumn = e
        },
        setAdv1(state, e){
            state.adv1 = e
        }
    },   //修改state
    actions: {},    //异步操作
    getters: {},     //计算属性
    modules: {},    //模块
    plugins: [createPersistedState({
        storage: window.sessionStorage,//可以改成localStore
        reducer(val) { //设置想要持久化保存的数据
            return {
                // limit:val.limit,
                // addColumn:val.addColumn,
                moreRecommend: val.moreRecommend,
                searchContent: val.searchContent,
                artrcleNumber: val.artrcleNumber,
                index: val.index,
                city: val.city,
                columnTitle: val.columnTitle,
            }
        },
    })]
})

export default store